import React, { useState, useContext } from "react";
import { TbCircleCheck } from "react-icons/tb";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import ButtonUI from "../../material-ui/ButtonUI";
import { AuthContext } from "../../../context/Auth/AuthContext";
import approveRequestedCase from "../../../api/approveRequestedCase";

const ApproveCasePopup = ({ tableValues, setCategoryUpdatedToTrue }) => {
  const [open, setOpen] = useState(false);
  const { token } = useContext(AuthContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onApproveDocumentFormSubmit = async () => {
    const approveCaseFormResponse = await approveRequestedCase({
      token: token,
      docId: tableValues.doc_id,
    });

    if (approveCaseFormResponse?.code === 200) {
      setOpen(false);
      setCategoryUpdatedToTrue();
      toast.success("Document is approved successfully", {
        position: "top-center",
        autoClose: 3000,
        theme: "dark",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return (
    <div className="dialog-modal">
      <ButtonUI
        formButton={false}
        variant="outlined"
        buttonText={<TbCircleCheck />}
        style={{
          backgroundColor:
            tableValues.status_c === "Uploaded" ? "#28a745" : "#d8d8e4df",
          // boxShadow:
          //   tableValues.status_c === "Uploaded"
          //     ? "0 0 0.4rem #2a9ceb57, inset 0 0 0 2px #2a9ceb57"
          //     : "none",
          color:
            tableValues.status_c === "Uploaded" ? "white" : "rgb(18 215 24)",
          marginRight: "5px",
        }}
        disabled={tableValues.status_c === "Uploaded" ? false : true}
        onClickFunc={handleClickOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <TbCircleCheck />
          </div>
          <div className="popup-header-title">Approve Document</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to approve this document ?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{
              margin: "15px 0px",
              marginTop: "0px",
              backgroundColor: "#fff",
              color: "#007bff",
              border: "1px solid #007bff",
            }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{
              margin: "15px",
              marginTop: "0px",
              backgroundColor: "#fff",
              color: "##007bff",
              border: "1px solid #007bff",
            }}
            autoFocus={true}
            onClickFunc={() => {
              onApproveDocumentFormSubmit();
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ApproveCasePopup;
